import { useState, useEffect } from "react";
import { Tabs } from "antd";
import Chat from "../../Components/PlayTabs/Chat";
import Query from "../../Components/PlayTabs/Query";
import History from "../../Components/PlayTabs/History";
import {
  MessageOutlined,
  FileSearchOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import "./Play.css";

const { TabPane } = Tabs;

function Play() {
  const [key, setKey] = useState("1");

  function callback(activeKey) {
    if (activeKey == "2") {
      //gtm
      window.dataLayer.push({
        event: "Chat with document",
        buttonName: "Chat with document button",
        userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
        clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
      });
    } else if (activeKey == "3") {
      //gtm
      window.dataLayer.push({
        event: "Chat History",
        buttonName: "Chat History button",
        userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
        clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
      });
    } else {
      //gtm
      window.dataLayer.push({
        event: "Chat ",
        buttonName: "Chat button",
        userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
        clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
      });
    }
    setKey(activeKey);
  }

  return (
    <div className="main-wrapper">
      <div className="flex gap-2">
        <img src="/images/Vector.svg" className="play-icon" alt="" />
        <p className="play-text">Play</p>
      </div>
      <div className="tabs-div">
        <Tabs
          defaultActiveKey="1"
          activeKey={key}
          onChange={callback}
          className="CustomTabs"
        >
          <TabPane
            tab={
              <span className="class-span">
                {" "}
                <img
                  className="img-tab"
                  src="/images/messages.svg"
                  alt=""
                />{" "}
                Chat
              </span>
            }
            key="1"
          >
            {key == "1" && <Chat key={key} setKey={setKey} />}
          </TabPane>
          <TabPane
            tab={
              <span className="class-span">
                {" "}
                <img
                  className="img-tab"
                  src="/images/receipt-search.svg"
                  alt=""
                />{" "}
                Chat with Documents
              </span>
            }
            key="2"
          >
            {key == "2" && <Query key={key} setKey={setKey} />}
          </TabPane>
          <TabPane
            tab={
              <span className="class-span">
                {" "}
                <img
                  className="img-tab"
                  src="/images/document-previous.svg"
                  alt=""
                />{" "}
                History
              </span>
            }
            key="3"
          >
            {key == "3" && <History key={key} setKey={setKey} />}
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default Play;
